import Lookup from 'src/componentes/select-async';
import Edit from 'src/paginas/EscritorioProjetos/FluxoAprovacaoGenerico/Edit';
import FluxoAprovacaoList from 'src/paginas/EscritorioProjetos/FluxoAprovacaoGenerico';

const FluxoAprovacaoGenericoLookup = ({ data, ...rest }) => (
  <Lookup
    showSearch
    labelKey="nome"
    valueKey="id"
    url="/FluxoAprovacaoGenericoLookup"
    editComponent={Edit}
    searchComponent={FluxoAprovacaoList}
    clearable
    {...rest}
    data={{
      ...data,
      ocultarFluxosSemEtapas: true,
    }}
  />
);

export default FluxoAprovacaoGenericoLookup;
